import React, { useEffect, useRef, useState } from "react";

function Divider({ type, color, className }) {
  const colorClass = {
    gray200: "bg-gray200",
    gray600: "bg-gray600",
    grayTrue800: "bg-grayTrue800",
  };

  return (
    <div
      className={`${colorClass[color]} ${className} ${
        type === "horizontal" ? "h-px w-full" : "h-full w-px"
      }`}
    />
  );
}

export default Divider;
